import { render, staticRenderFns } from "./LayoutDefault2021.vue?vue&type=template&id=311e7307&scoped=true&"
import script from "./LayoutDefault2021.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault2021.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefault2021.vue?vue&type=style&index=0&id=311e7307&scoped=true&lang=scss&"
import style1 from "./LayoutDefault2021.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311e7307",
  null
  
)

component.options.__file = "LayoutDefault2021.vue"
export default component.exports